// ===== NavbarItem/NavbarItemActions.js =====
import { useMemo } from 'react';
import {
  Folder,
  FolderOpen,
  Description
} from '@mui/icons-material';

export const useNavbarItemActions = ({
  item,
  isExpanded,
  setIsExpanded,
  onItemClick
}) => {
  
  const hasChildren = useMemo(() => {
    // Check both nested structure and flat structure flag
    if (item.children && item.children.length > 0) {
      return true;
    }
    return item.hasChildren || false;
  }, [item.children, item.hasChildren]);
  
  const handleToggle = (e) => {
    // Check if event exists before calling stopPropagation
    if (e && e.stopPropagation) {
      e.stopPropagation();
    }
    setIsExpanded(!isExpanded);
  };
  
  const handleItemClick = () => {
    // If it has children, ONLY toggle expansion (don't call onItemClick)
    if (hasChildren) {
      setIsExpanded(!isExpanded);
    } else {
      // Only call onItemClick for leaf nodes (no children)
      if (onItemClick) {
        onItemClick(item);
      }
    }
  };
  
  const getIcon = () => {
    if (item.icon) {
      return item.icon;
    }
    
    // Default icons based on whether item has children
    if (hasChildren) {
      return isExpanded ? <FolderOpen /> : <Folder />;
    }
    return <Description />;
  };
  
  return {
    handleToggle,
    handleItemClick,
    getIcon,
    hasChildren
  };
};

// Additional action utilities
export const navbarUtils = {
  findItemById: (items, id) => {
    for (const item of items) {
      if (item.id === id) return item;
      if (item.children) {
        const found = navbarUtils.findItemById(item.children, id);
        if (found) return found;
      }
    }
    return null;
  },
  
  getAllItemIds: (items) => {
    const ids = [];
    const traverse = (items) => {
      items.forEach(item => {
        ids.push(item.id);
        if (item.children) {
          traverse(item.children);
        }
      });
    };
    traverse(items);
    return ids;
  },
  
  getItemPath: (items, targetId) => {
    const path = [];
    const findPath = (items, targetId, currentPath = []) => {
      for (const item of items) {
        const newPath = [...currentPath, item.id];
        if (item.id === targetId) {
          return newPath;
        }
        if (item.children) {
          const found = findPath(item.children, targetId, newPath);
          if (found) return found;
        }
      }
      return null;
    };
    return findPath(items, targetId);
  }
};